export default __webpack_public_path__ + "static/media/faq.801fe4b0.png";